"use client";

import React from "react";
import { Navigation, PackageCheck, Leaf, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Fully Insured",
  description: "Complete peace of mind with comprehensive coverage for every item we move.",
  icon: ShieldCheck
}, {
  title: "Real-Time Tracking",
  description: "Monitor your shipment's journey with precision GPS updates at every mile.",
  icon: Navigation
}, {
  title: "Expert Handling",
  description: "Our elite crew is trained in specialized techniques for high-value logistics.",
  icon: PackageCheck
}, {
  title: "Eco-Friendly",
  description: "Sustainable packing solutions and optimized routes to reduce our carbon footprint.",
  icon: Leaf
}];
const brands = [{
  name: "Residential",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/residential_moving_icon.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/residential_moving_icon.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/residential_moving_icon.png-wvc-sizes"
}, {
  name: "Commercial",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/commercial_logistics_icon.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/commercial_logistics_icon.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/commercial_logistics_icon.png-wvc-sizes"
}, {
  name: "Storage",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/secure_storage_icon.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/secure_storage_icon.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/secure_storage_icon.png-wvc-sizes"
}, {
  name: "Packing",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/premium_packing_icon.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/premium_packing_icon.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/premium_packing_icon.png-wvc-sizes"
}, {
  name: "Long Distance",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/interstate_transit_icon.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/interstate_transit_icon.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/interstate_transit_icon.png-wvc-sizes"
}];
export default function TheShiftStandard() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: brandsRef,
    isVisible: isBrandsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261946" id="the-shift-standard" className="dark bg-background pt-16 md:pt-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {}
        <div ref={headerRef} className={`mb-16 text-center transition-all duration-700 ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-default text-foreground mb-6 text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl uppercase">
            The Shift Standard of Excellence
          </h2>
          <div className="bg-primary mx-auto h-1 w-16 rounded-md"></div>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-12 transition-all duration-1000 delay-200 ${isGridVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                <div className="bg-secondary text-primary mb-6 flex h-16 w-16 items-center justify-center rounded-md shadow-md transition-transform duration-300 group-hover:scale-110 border border-border">
                  <Icon className="h-8 w-8" />
                </div>
                <h3 className="font-default text-foreground mb-3 text-xl font-bold">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground font-default text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>

      {}
      <div ref={brandsRef} className={`bg-secondary/50 border-border mt-20 border-y py-10 transition-all duration-1000 delay-300 ${isBrandsVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-center gap-8 px-4 md:flex-row lg:gap-12">
          <div className="flex items-center gap-6">
            <span className="font-default text-foreground text-lg font-bold whitespace-nowrap uppercase tracking-wider">
              Certified <span className="text-primary">Logistics</span>
            </span>
            <div className="bg-primary hidden h-8 w-1 rounded-md md:block"></div>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-10 lg:gap-12">
            {brands.map((brand, i) => <img key={i} data-index={i} src={brand.src} data-wvc-srcset={brand.srcset} data-wvc-sizes={brand.sizes} alt={`${brand.name} logo`} className={`h-8 w-auto object-contain transition-all md:h-10 opacity-100 grayscale-0 hover:opacity-100 hover:grayscale-0`} loading="lazy" />)}
          </div>
        </div>
      </div>
    </section>;
}